import React, { useReducer, useState } from "react";
import PropTypes from "prop-types";
import GiftTable from "../../elements/Tables/GiftTable/GiftTable";
import GiftCreationForm from "../../elements/Forms/GiftCreationForm/GiftCreationForm";

import { useFetch } from "../../../Utils/useFetch";

import {
  FETCH_ALL_GIFT_API,
} from "../../../Constants/Apis"
import { Button, Flex, Input, message, Modal } from "antd";
import { reducer } from "../../../Utils/CommonUtils";
import { deleteGift } from "../../../Services/GiftService";

const { Search } = Input;

const GiftPage = ({ history, userData }) => {
  const initialState = {
    searchKeyword: "",
    filteredInfo: {},
    sorter: {},
  };

  const [state, dispatch] = useReducer(reducer, initialState);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [giftId, setGiftId] = useState(null);

  const handleOpenModal = () => setIsModalVisible(true);
  const handleCloseModal = () => setIsModalVisible(false);

  const handleDelete = async (id) => {
    setGiftId(id);
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    try {
      await deleteGift(giftId);
      message.success("Gift deleted successfully");
      callReFetch();
    } catch (error) {
      message.error(
        error?.response?.data?.message ||
          "Something went wrong, failed to delete gift."
      );
    }
    setIsModalOpen(false);
  };

  const {
    fetchedData: { data },
    callReFetch,
    loading,
  } = useFetch(`${FETCH_ALL_GIFT_API}`, state);

  const handleSearch = (value) => {
    dispatch({ type: "searchKeyword", payload: value });
    callReFetch();
  };

  return (
    <div style={{ width: "100vw", padding: "20px", boxSizing: "border-box", display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
      <div
        style={{
          paddingBottom: "20px",
          display: "flex",
          justifyContent: "space-between",
          width: "50vw",
          maxWidth: "100vw",
        }}
      >
        <Button type="primary" onClick={handleOpenModal}>
          Create New Gift
        </Button>
        <Search
          placeholder="Search..."
          allowClear
          onSearch={handleSearch}
          style={{ width: "300px" }}
        />
      </div>

      <GiftTable
        history={history}
        loading={loading}
        data={data}
        callReFetch={callReFetch}
        dispatch={dispatch}
        handleDelete={handleDelete}
      />

      <Modal
        title="Create Gift"
        open={isModalVisible}
        footer={null}
        onCancel={handleCloseModal}
      >
        <GiftCreationForm
          history={history}
          userData={userData}
          callReFetch={callReFetch}
          onClose={handleCloseModal}
        />
      </Modal>

      <Modal
        title="Delete Gift"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={() => setIsModalOpen(false)}
      >
        <p>Are you sure you want to delete this gift?</p>
      </Modal>
    </div>
  );
};

GiftPage.propTypes = {};

export default GiftPage;
